import React from 'react';
import { Alert } from 'antd';

import StandardSteps from 'components/StandardSteps';
import StatusRadioGroup from 'components/StatusRadioGroup';

export default class TranscriptStatus extends React.Component {
	render() {
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'academic/transcriptstatus');
			if (redirect) return redirect;
		}

		const code = (this.props.statuses) ? this.props.statuses.SRI_UPDATED_TRAN: null;
		if (this.props.variant === 'admin') {
			return (
				<div className="withSpacing">
					{this.props.statusesLoaded &&
						<StatusRadioGroup
							statusType="SRI_UPDATED_TRAN"
							onChange={this.props.handleStatusChange}
							value={code} />
					}
				</div>
			);
		} else {
			return (
				<div>
					<Alert showIcon type="info"
						message={<span>Please read: <a target="_blank" href="https://www.semesteratsea.org/event/fa19-final-spring-2019-grades-due/">Transcript Instructions</a></span>}
						description="Bring an updated copy of your transcript with you to the ship" />
						<br />
					<StandardSteps code={code} />
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/Academic/TranscriptStatus.jsx